import { t } from "@lingui/macro";
import { DataTable } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import type { FC } from "react";
import { useStore } from "../../store";

export const Summary: FC<{ isLoaded: boolean }> = observer(function Summary({
  isLoaded,
}) {
  const store = useStore();

  const {
    invoices,
    total_amount_with_vat,
    payments_due,
    overdue_by_less_than_30_days,
    overdue_by_31_to_90_days,
    overdue_by_91_to_365_days,
    overdue_by_more_than_365_days,
  } = store.proformaInvoicesSummary ?? {
    invoices: 0,
    total_amount_with_vat: 0,
    payments_due: 0,
    overdue_by_less_than_30_days: 0,
    overdue_by_31_to_90_days: 0,
    overdue_by_91_to_365_days: 0,
    overdue_by_more_than_365_days: 0,
  };

  return (
    <DataTable.SummaryBox justify="space-between">
      <DataTable.SummaryItem label={t`Proforma invoices`} isLoaded={isLoaded}>
        {invoices}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem label={t`Amount total (VAT)`} isLoaded={isLoaded}>
        {currency.formatByWorkspace(total_amount_with_vat, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem label={t`Current`} isLoaded={isLoaded}>
        {currency.formatByWorkspace(payments_due, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem
        label={t`Overdue less than 30 days`}
        isLoaded={isLoaded}
      >
        {currency.formatByWorkspace(overdue_by_less_than_30_days, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem
        label={t`Overdue by 31-90 days`}
        isLoaded={isLoaded}
      >
        {currency.formatByWorkspace(overdue_by_31_to_90_days, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem
        label={t`Overdue by 91-365 days`}
        isLoaded={isLoaded}
      >
        {currency.formatByWorkspace(overdue_by_91_to_365_days, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
      <DataTable.SummaryItem
        label={t`Overdue by more than 365 days`}
        isLoaded={isLoaded}
      >
        {currency.formatByWorkspace(overdue_by_more_than_365_days, {
          czkNoFractionDigits: true,
        })}
      </DataTable.SummaryItem>
    </DataTable.SummaryBox>
  );
});
